'use strict';

var _utility = require('./helpers/utility');

var Minhac = {
    Util: _utility.util
};

module.exports = {
    Minhac: Minhac
};